import axios from "axios";
import {getConfig} from "@/config/config";
import {useAuthStore} from "@/stores/auth.store";
import router, {PagesEnum} from "@/router";

const client = axios.create({
    baseURL: getConfig().BACKEND_ENDPOINT,
});

client.interceptors.request.use(async function (config) {
    const user = useAuthStore().getUser
    if (user) {
        const fallbackCached = (user as any).stsTokenManager.accessToken
        const token = (await user.getIdToken?.()) || fallbackCached

        if (token && config.headers) {
            config.headers.Authorization = `Bearer ${token}`;
        }
    }
    return config;
});

client.interceptors.response.use(function (response) {
    return response;
}, async function (error) {
    const {response} = error

    if (response.status === 401) {
        console.log(error.data?.message)
        // useNotifications().fail(res.data?.message)
        await router.push({ name: PagesEnum.SIGN_IN})
    }

    return Promise.reject(error)
});


export const backendClient = client;
